import { liveStats } from './liveStats'
import kvSyncSubscriber from './kvSync'

function init() {
  liveStats.connect()
  kvSyncSubscriber.init()
}

export default { init }
